<div *ngIf="visible">
  <i nz-icon nzType="link" nzTheme="outline" class="icon"></i>
</div>
